import graphql, { getData } from 'api/graphql'
import {
  USAGE_INBOX_MAILBOXES,
  USAGE_INBOX_CHANNELS,
  USAGE_INBOX_INTEGRATIONS,
  USAGE_INBOX_USERS,
  USAGE_INBOX_TEAMS,
  USAGE_INBOX_SATISFACTIONS_RATINGS,
  USAGE_INBOX_RULES,
  USAGE_INBOX_CUSTOM_PROFILE,
  USAGE_INBOX_CANNED_REPLIES,
  USAGE_INBOX_PREMIUM_INTEGRATIONS,
  USAGE_INBOX_FOLDERS,
  USAGE_INBOX_RULES_TIER_1,
  USAGE_INBOX_RULES_TIER_2,
  USAGE_INBOX_CANNED_REPLIES_TIER_1,
  USAGE_INBOX_WIDGETS,
  USAGE_KB_KBS,
  USAGE_KB_ARTICLES,
  USAGE_KB_BRANDING,
  USAGE_KB_CUSTOM_SCRIPTS,
  USAGE_KB_PRIVATE,
  USAGE_INBOX_API_ACCESS,
  USAGE_INBOX_WEBHOOKS,
  USAGE_INBOX_CUSTOM_FIELDS,
  USAGE_INBOX_BRANDING,
} from './usageTypes'

export const CREDIT_CARD_FIELDS = `
id
brand
expiryMonth
expiryYear
last4
`

const BILLING_USAGE_FIELDS = `
inbox {
  ${USAGE_INBOX_MAILBOXES}
  ${USAGE_INBOX_CHANNELS}
  ${USAGE_INBOX_INTEGRATIONS}
  ${USAGE_INBOX_USERS}
  ${USAGE_INBOX_TEAMS}
  ${USAGE_INBOX_SATISFACTIONS_RATINGS}
  ${USAGE_INBOX_RULES}
  ${USAGE_INBOX_CUSTOM_PROFILE}
  ${USAGE_INBOX_CANNED_REPLIES}
  ${USAGE_INBOX_PREMIUM_INTEGRATIONS}
  ${USAGE_INBOX_FOLDERS}
  ${USAGE_INBOX_RULES_TIER_1}
  ${USAGE_INBOX_RULES_TIER_2}
  ${USAGE_INBOX_CANNED_REPLIES_TIER_1}
  ${USAGE_INBOX_WIDGETS}
  ${USAGE_INBOX_API_ACCESS}
  ${USAGE_INBOX_WEBHOOKS}
  ${USAGE_INBOX_CUSTOM_FIELDS}
  ${USAGE_INBOX_BRANDING}
}
kb {
  ${USAGE_KB_KBS}
  ${USAGE_KB_ARTICLES}
  ${USAGE_KB_BRANDING}
  ${USAGE_KB_CUSTOM_SCRIPTS}
  ${USAGE_KB_PRIVATE}
}
`

export const BILLING_PLANS_FIELDS = `
  plans {
    name
    product
    planId
    monthlyPrice
    annualPrice
    active
    minimumQuantity
    features
    pricingModel
    version
  }
`

export const basicFields = `
  provider
  createdAt
  state
  cc_last4
  has_legacy_kb
  billing_cycle
  cancels_at
  kb {
    state
    plan
    expires_at
    has_completed_trial
    features
    quantity
    version
    pricingModel
  }
  inbox {
    state
    plan
    expires_at
    has_completed_trial
    features
    quantity
    version
    pricingModel
  }
  usage {
    ${BILLING_USAGE_FIELDS}
  }
  hasLastBillingFailed
  isPaid
  pendingSubscription {
    approvalUrl
    inboxPlan
    kbPlan
    billingCycle
    state
  }
  futurePhase {
    startDate
    items {
      plan
      quantity
    }
  }
  externalAccountId
  externalSubscriptionId
`

export const EXTENDED_BILLING_FIELDS = `
  state
  cc_last4
  has_legacy_kb
  billing_cycle
  cancels_at
  kb {
    state
    plan
    expires_at
    has_completed_trial
    features
    quantity
    version
    pricingModel
  }
  inbox {
    state
    plan
    expires_at
    has_completed_trial
    features
    quantity
    version
    pricingModel
  }
  account {
    upcomingInvoice {
      id
      total
      nextPaymentAttempt
      amountDue
      currency
      lines {
        amount
        proration
      }
    }
    creditBalance
  }
  usage {
    ${BILLING_USAGE_FIELDS}
  }
  pendingSubscription {
    approvalUrl
    inboxPlan
    kbPlan
    billingCycle
    state
  }
  hasLastBillingFailed
  externalAccountId
  externalSubscriptionId
  startTrialDurationDays
  futurePhase {
    startDate
    items {
      plan
      quantity
    }
  }
`

const BILLING_DATA_QUERY = `
  query BillingDataQuery {
    billing {
      ${EXTENDED_BILLING_FIELDS}
    }
    creditCards {
      ${CREDIT_CARD_FIELDS}
    }
  }
`

export const INVOICES_DATA_QUERY = `
query InvoicesDataQuery {
  invoices {
    id
    paid
    periodStart
    periodEnd
    number
    hostedInvoiceUrl
    invoicePdf
    total
    date
    currency
    status
    lines {
      period {
        start
        end
      }
      plan {
        id
      }
    }
  }
}
`

export const BILLING_INFORMATION_FIELDS = `
name
phone
city
country
line1
line2
postalCode
state
vatId
`

const BILLING_INFORMATION_DATA_QUERY = `
query BillingInformationDataQuery {
  billingInformation {
    ${BILLING_INFORMATION_FIELDS}
  }
}
`

export const fetchBillingData = token => {
  return graphql(token, BILLING_DATA_QUERY).then(getData)
}

export const fetchBillingInformation = token => {
  return graphql(token, BILLING_INFORMATION_DATA_QUERY).then(getData)
}

export const billingQuery = () => `
  query BillingQuery {
    billing {
      ${basicFields}
    }
    creditCards {
      ${CREDIT_CARD_FIELDS}
    }
    ${BILLING_PLANS_FIELDS}
  }
`
